import * as req from 'api/actions';
import * as c from './constant';

export const assessReceipt = (id, payload, callback) =>
  req.update(
    c.ASSESS_RECEIPT,
    `/api/v1/administrators/transaction_histories/${id}/assess_payment_receipt`,
    payload,
    callback,
    (res) => {
      const { message } = res.res;
      alert.success(message || 'Successfully Updated !');
      if (callback) callback();
    }
  );

export const getTransactionList = (
  payload = { module_type: 'CDL' },
  callback
) =>
  req.list(
    c.GET_TRANSACTION,
    'api/v1/administrators/transaction_histories/',
    payload,
    callback
  );

export const showTransaction = (id, payload, callback) =>
  req.item(
    c.SHOW_TRANSACTION,
    `api/v1/administrators/transaction_histories/${id}`,
    payload,
    callback
  );

export const updateTransaction = (id, payload, callback) =>
  req.update(
    c.UPDATE_TRANSACTION,
    `api/v1/administrators/transaction_histories/${id}`,
    payload,
    callback,
    (res) => {
      const { message } = res.res;
      alert.success(message || 'Successfully Updated !');
      if (callback) callback();
    }
  );

export const approveTransaction = (id, payload, callback) =>
  req.update(
    c.APPROVE_TRANSACTION,
    `api/v1/administrators/transaction_histories/cedula/${id}/tag_as_received`,
    payload,
    callback,
    (res) => {
      const { message } = res.res;
      alert.success(message || 'Successfully Updated !');
      if (callback) callback();
    }
  );

export const tagAsPrintedTransaction = (id, payload, callback) =>
  req.update(
    c.TAG_AS_PRINTED_TRANSACTION,
    `api/v1/administrators/transaction_histories/cedula/${id}/tag_as_printed`,
    payload,
    callback,
    (res) => {
      const { message } = res.res;
      alert.success(message || 'Successfully Updated !');
      if (callback) callback();
    }
  );

export const startAssessment = (id, callback) =>
  req.update(
    c.START_ASSESSMENT,
    `api/v1/administrators/transaction_histories/${id}/start_assessment`,
    callback,
    ({ res }) => {
      const { data } = res.res;
      if (callback) callback({ data });
    }
  );

export const clearTransaction = () => req.setList(c.GET_TRANSACTION, []);

export const getSettings = (card_type, callback) =>
  req.item(c.GET_SETTINGS, `/api/v1/administrators/ohp_settings`, callback, {
    card_type,
  });

export const updatedHealthStatus = (id, payload, callback) =>
  req.update(
    c.UPDATE_TEST_STATUS,
    `api/v1/administrators/occupational_health_permits/${id}`,
    payload,
    callback
  );

export const checkOr = (
  payload,
  callback
) =>
  req.list(
    c.OR_CHECK,
    `api/v1/administrators/transaction_histories/cedula/check_or`,
    payload,
    callback
  );

export const updateCdl = (id, payload, callback) =>
  req.update(
    c.UPDATE_CDL,
    `api/v1/administrators/transaction_histories/cedula/corporation/${id}/update`,
    payload,
    callback
  );

export const getRegionList = (payload, callback) =>
  req.list(
    c.GET_REGION,
    'api/v1/administrators/address/regions',
    payload,
    callback
  );

export const getProvinceList = (payload, callback) =>
  req.list(
    c.GET_PROVINCE,
    'api/v1/administrators/address/provinces',
    payload,
    callback
  );

export const getMunicipalityList = (payload, callback) =>
  req.list(
    c.GET_MUNICIPALITIES,
    'api/v1/administrators/address/municipalities',
    payload,
    callback
  );

export const getBarangayList = (payload, callback) =>
  req.list(
    c.GET_BARANGAYS,
    'api/v1/administrators/address/barangays',
    payload,
    callback
  );

export const getBusinessLines = (payload, callback) => req.list(
  `${c.GET_BUSINESS_LINES}`,
  '/api/v1/administrators/line_businesses/?is_paginated=0',
  payload,
  callback,
);

export const getBusinessNatures = (lineCode, payload = {}, callback) => req.list(
  `${c.GET_BUSINESS_NATURE}`,
  `/api/v1/administrators/line_businesses/${lineCode}/nature_businesses?is_paginated=0`,
  {
    ...payload
  },
  callback,
);

export const updateAmount = (id, payload, callback) =>
  req.update(
    c.UPDATE_AMOUNT,
    `api/v1/administrators/transaction_histories/cedula/${id}/paid_amount`,
    payload,
    callback,
    (res) => {
      const { message } = res.res;
      alert.success(message || 'Successfully Updated !');
      if (callback) callback();
    }
  );